import { Header } from "../components/Header";
import { Hero } from "../components/sections/Hero";
import { Gallery } from "../components/sections/Gallery";
import { Amenities } from "../components/sections/Amenities";
import { Location } from "../components/sections/Location";
import { CarRental } from "../components/sections/CarRental";
import { Village } from "../components/sections/Village";
import { Pricing } from "../components/sections/Pricing";
import { Reviews } from "../components/sections/Reviews";
import { Availability } from "../components/sections/Availability";
import { Contact } from "../components/sections/Contact";
import { Footer } from "../components/sections/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#FAF8F5]">
      <Header />
      <main>
        <Hero />
        <Gallery />
        <Amenities />
        <Location />
        <CarRental />
        <Village />
        <Pricing />
        <Reviews />
        <Availability />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
